import { render, staticRenderFns } from "./OnlineWaTemplatesPicker.vue?vue&type=template&id=032478d8&scoped=true&"
import script from "./OnlineWaTemplatesPicker.vue?vue&type=script&lang=js&"
export * from "./OnlineWaTemplatesPicker.vue?vue&type=script&lang=js&"
import style0 from "./OnlineWaTemplatesPicker.vue?vue&type=style&index=0&id=032478d8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032478d8",
  null
  
)

export default component.exports